<template>
  <div class="q-pa-sm">
    <q-breadcrumbs>
      <q-breadcrumbs-el icon="home" label="首頁" to="/index"/>
      <q-breadcrumbs-el :label="pathData.main.title" :icon="pathData.main.icon" :to="pathData.main.path + '/list'"/>
      <q-breadcrumbs-el v-show="pathMethod !== ''" v-if="pathMethod !== ''" :label="pathData.sub.meta.title" :icon="pathData.sub.meta.icon"/>
    </q-breadcrumbs>
  </div>
</template>

<script>
  import { staticRouter } from '../router'
  export default {
    name: "Breadcrumbs",
    props: {
      pathName: {
        type: String,
        default: ''
      },
      pathMethod: {
        type: String,
        default: ''
      }
    },
    created() {
      var find = staticRouter.find(row => row.name === this.pathName)
      this.pathData.main = find
      if (this.pathMethod !== '') {
        this.pathData.sub = find.children.find(row => row.type === this.pathMethod)
      }
    },
    data() {
      return {
        pathData: {
          main: {},
          sub: {}
        }
      }
    }
  }
</script>

<style scoped>

</style>